import MDinput from '@/components/MDinput';
import { validatorEmail, validatorRequire } from '@/utils/validators';
import PickRec from '@/components/DSE/PickRec';
import { DomainTypeOption } from '@/utils/constants';

export function getFormDefinition(vue) {
  return {
    id: {
      type: null,
      defaultValue: undefined
    },
    name: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    code: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255,
        required: true,
        caption: 'login.code'
      },
      rules: [
        {
          validator: validatorRequire
        }
      ]
    },
    email: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true,
        caption: 'common.email'
      },
      rules: [
        {
          validator: validatorRequire
        },
        {
          validator: validatorEmail
        }
      ]
    },
    avatar: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255,
        caption: 'user.avatar'
      }
    },
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 255
      }
    },
    storeID: {
      type: PickRec,
      defaultValue: null,
      props: {
        caption: 'common.store',
        valueField: 'id',
        labelField: 'name',
        inputField: 'code',
        maxlength: 64,
        columns: [
          { field: 'clientName', label: 'storeUser.clientName' },
          { field: 'code', label: 'storeUser.storeCode' },
          { field: 'name', label: 'storeUser.storeName' }
        ],
        entity: 'Store',
        required: true,
        usePagination: true,
        hideInput: false,
        suggest: true,
        filters: {
          domainType: DomainTypeOption.InteriorDecorator
        }
      },
      rules: [{ validator: validatorRequire }]
    }
  };
}

export function createItemFromFormData(vue, form) {
  const user = {
    ...form,
    roles: []
  };
  if (form.id) {
    user['id'] = form.id;
  }
  return user;
}

export function createFormDataFromItem(vue, user) {
  const form = {
    ...user
  };
  return form;
}
